export default __webpack_public_path__ + "static/media/fly-shape.b78d7f27.svg";